import React from "react";
import createWidgetComponent from "@src/components/widgets/HOC/createWidgetComponent";
import type { WidgetTemplateComponentType } from "@src/interface/Widget";

/**
 * Un import dynamique par fichier sous `template-loaders/` : webpack ne fusionne pas
 * tous les templates dans un seul chunk async (contrairement à un switch unique).
 */
function loadLandingStandardTemplate(
  template: string
): Promise<{ default: WidgetTemplateComponentType<any> }> {
  switch (template) {
    case "header":
      return import("./template-loaders/header").then((m) => m.default());
    case "header-margaux-motin":
      return import("./template-loaders/header-margaux-motin").then((m) =>
        m.default()
      );
    case "highlight-product":
      return import("./template-loaders/highlight-product").then((m) =>
        m.default()
      );
    case "highlight-product-umami":
      return import("./template-loaders/highlight-product-umami").then((m) =>
        m.default()
      );
    case "highlight-product-margaux-motin":
      return import(
        "./template-loaders/highlight-product-margaux-motin"
      ).then((m) => m.default());
    case "video":
      return import("./template-loaders/video").then((m) => m.default());
    case "video-margaux-motin":
      return import("./template-loaders/video-margaux-motin").then((m) =>
        m.default()
      );
    case "menu":
      return import("./template-loaders/menu").then((m) => m.default());
    case "menu-margaux-motin":
      return import("./template-loaders/menu-margaux-motin").then((m) =>
        m.default()
      );
    case "footer":
      return import("./template-loaders/footer").then((m) => m.default());
    case "footer-margaux-motin":
      return import("./template-loaders/footer-margaux-motin").then((m) =>
        m.default()
      );
    case "about":
      return import("./template-loaders/about").then((m) => m.default());
    case "about-margaux-motin":
      return import("./template-loaders/about-margaux-motin").then((m) =>
        m.default()
      );
    case "innovations":
    case "innovations-v2":
      return import("./template-loaders/innovations").then((m) =>
        m.default()
      );
    case "innovations-umami":
      return import("./template-loaders/innovations-umami").then((m) =>
        m.default()
      );
    case "innovations-margaux-motin":
      return import("./template-loaders/innovations-margaux-motin").then((m) =>
        m.default()
      );
    case "engagements":
    case "engagements-v2":
      return import("./template-loaders/engagements").then((m) =>
        m.default()
      );
    case "introduction":
      return import("./template-loaders/introduction").then((m) =>
        m.default()
      );
    case "play-pacman":
      return import("./template-loaders/play-pacman").then((m) =>
        m.default()
      );
    case "push-apps-margaux-motin":
      return import("./template-loaders/push-apps-margaux-motin").then((m) =>
        m.default()
      );
    case "header-with-highlight-product-petit-prince":
      return import(
        "./template-loaders/header-with-highlight-product-petit-prince"
      ).then((m) => m.default());
    case "innovation-petit-prince":
      return import("./template-loaders/innovation-petit-prince").then((m) =>
        m.default()
      );
    case "about-with-footer-petit-prince":
      return import(
        "./template-loaders/about-with-footer-petit-prince"
      ).then((m) => m.default());
    case "highlight-two-products":
      return import("./template-loaders/highlight-two-products").then((m) =>
        m.default()
      );
    case "header-adrien-cachot":
      return import("./template-loaders/header-adrien-cachot").then((m) =>
        m.default()
      );
    case "highlight-product-adrien-cachot":
      return import(
        "./template-loaders/highlight-product-adrien-cachot"
      ).then((m) => m.default());
    case "innovations-adrien-cachot":
      return import("./template-loaders/innovations-adrien-cachot").then((m) =>
        m.default()
      );
    case "signature-chef":
      return import("./template-loaders/signature-chef").then((m) =>
        m.default()
      );
    case "video-slider-adrien-cachot":
      return import("./template-loaders/video-slider-adrien-cachot").then((m) =>
        m.default()
      );
    case "about-adrien-cachot":
      return import("./template-loaders/about-adrien-cachot").then((m) =>
        m.default()
      );
    case "footer-adrien-cachot":
      return import("./template-loaders/footer-adrien-cachot").then((m) =>
        m.default()
      );
    case "default":
    default:
      return import("./template-loaders/debug").then((m) => m.default());
  }
}

const LandingStandardWidget = createWidgetComponent({
  displayName: "LandingStandardWidget",
  loadTemplate: loadLandingStandardTemplate,
  suspenseFallback: () => <div />,
});

LandingStandardWidget.displayName = "LandingStandardWidget";

export default LandingStandardWidget;
